var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_469_996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99902 0C3.1334 0 -0.000976562 3.13437 -0.000976562 7C-0.000976562 10.8656 3.1334 14 6.99902 14C10.8646 14 13.999 10.8656 13.999 7C13.999 3.13437 10.8646 0 6.99902 0ZM6.99902 12.8125C3.78965 12.8125 1.18652 10.2094 1.18652 7C1.18652 3.79063 3.78965 1.1875 6.99902 1.1875C10.2084 1.1875 12.8115 3.79063 12.8115 7C12.8115 10.2094 10.2084 12.8125 6.99902 12.8125Z",
    fill: "#0c3255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.74253 3.94795C8.27378 3.53701 7.65503 3.31201 6.99878 3.31201C6.34253 3.31201 5.72378 3.53857 5.25503 3.94795C4.76753 4.37451 4.49878 4.94795 4.49878 5.56201V5.68076C4.49878 5.74951 4.55503 5.80576 4.62378 5.80576H5.37378C5.44253 5.80576 5.49878 5.74951 5.49878 5.68076V5.56201C5.49878 4.87295 6.17222 4.31201 6.99878 4.31201C7.82534 4.31201 8.49878 4.87295 8.49878 5.56201C8.49878 6.04795 8.15503 6.49326 7.62222 6.69795C7.29097 6.82451 7.00972 7.04639 6.80815 7.33701C6.60347 7.63389 6.49722 7.99014 6.49722 8.35107V8.68701C6.49722 8.75576 6.55347 8.81201 6.62222 8.81201H7.37222C7.44097 8.81201 7.49722 8.75576 7.49722 8.68701V8.33232C7.49803 8.18064 7.54452 8.03272 7.63065 7.90785C7.71677 7.78298 7.83853 7.68697 7.98003 7.63232C8.90191 7.27764 9.49722 6.46514 9.49722 5.56201C9.49878 4.94795 9.23003 4.37451 8.74253 3.94795ZM6.37378 10.437C6.37378 10.6028 6.43963 10.7617 6.55684 10.879C6.67405 10.9962 6.83302 11.062 6.99878 11.062C7.16454 11.062 7.32351 10.9962 7.44072 10.879C7.55793 10.7617 7.62378 10.6028 7.62378 10.437C7.62378 10.2713 7.55793 10.1123 7.44072 9.99507C7.32351 9.87786 7.16454 9.81201 6.99878 9.81201C6.83302 9.81201 6.67405 9.87786 6.55684 9.99507C6.43963 10.1123 6.37378 10.2713 6.37378 10.437Z",
    fill: "#0c3255"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_469_996"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(-0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.4fc46cba79591c6b973d9a4f2b29d138.svg";
export { ForwardRef as ReactComponent };